import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const routePath = route.routeConfig?.path ?? '';

    if (localStorage.getItem('userType') === 'organization') {
      return true;
    }

    const requiredPermission = this.getPermissionForRoute(routePath);
    const subUser = localStorage.getItem('subUser');

    if (!subUser) {
      this.router.navigate(['/']);
      return false;
    }

    let parsedData;
    try {
      parsedData = JSON.parse(subUser);
    } catch (error) {
      console.error('Erro ao parsear subUser do localStorage:', error);
      this.router.navigate(['/']);
      return false;
    }

    const permissions: string[] = parsedData.permissions || [];

    if (!requiredPermission || this.hasPermission(permissions, requiredPermission)) {
      return true;
    }

    this.openSnackBar('Você não possui permissão para acessar esse menu!', 'warning');
    return false;
  }

  private hasPermission(permissions: string[], requiredPermission: string): boolean {
    return permissions.includes(`${requiredPermission}:manage`);
  }

  private getPermissionForRoute(routePath: string): string | null {
    const permissionsMap: { [key: string]: string } = {
      '': 'DASHBOARD',
      'calendario': 'SCHEDULE',
      'agendados': 'ENCOUNTER',
      'especialistas': 'PRACTITIONERS',
      'exames': 'HEALTHCARES',
      'plano-saude': 'AGREEMENTS',
      'meus-dados': 'MY_DATA',
      'usuarios': 'SUBUSERS',
      'pacientes': 'PATIENTS',
    };

    return permissionsMap[routePath] ?? null;
  }

  openSnackBar(message: string, status: 'success' | 'error' | 'warning') {
    this.snackBar.open(message, '', {
      duration: 2000,
      panelClass: status === 'success' ? 'snack-success' : status === 'error' ? 'snack-error' : 'snack-warning',
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }
}
